import { Component, Input, OnInit } from '@angular/core';

import { ZusPodatki } from '../../../shared/models/zus.model';
import { SumowanieKwotService } from '../../../@core/utils/sumowanie-kwot.service';
import { TranslateService } from '@ngx-translate/core';
import { KomunikatyTabeli, KomunikatyTabeliService } from '../../../@core/utils/komunikaty-tabeli.service';
import { ZakresDat } from '../../../shared/models/zakres-dat.model';

@Component({
  selector: 'ngx-zus-podatki-tabela',
  templateUrl: './zus-podatki-tabela.component.html',
  styleUrls: ['./zus-podatki-tabela.component.scss'],
})
export class ZusPodatkiTabelaComponent implements OnInit {

  _dane: ZusPodatki[];

  @Input()
  zakresDat: ZakresDat;

  temp = [];
  eksportKolumny = [];
  eksportPdfKolumnyStyle;
  wyswietlanieFiltrow = false;

  @Input() set dane(value: ZusPodatki[]) {
    if (value) {
      this.temp = [...value];
      this._dane = value;
    }
  }

  get dane(): ZusPodatki[] {
    return this._dane;
  }

  komunikatyTabeli: KomunikatyTabeli;

  constructor(
    private readonly komunikatyTabeliService: KomunikatyTabeliService,
    private readonly translate: TranslateService,
    ) { }

  ngOnInit() {
    this.odswiezKomunikatyTabeli();
    this.translate.onLangChange.subscribe(() => this.odswiezKomunikatyTabeli());

    this.odswiezKolumnyPdf();
    this.translate.onLangChange.subscribe(() => this.odswiezKolumnyPdf());
  }

  updateFilter(event, prop) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function (d) {
      return (d[prop] != null && d[prop].toString().toLowerCase().indexOf(val) !== -1) || !val;
    });
    this._dane = temp;
  }

  sumaKwota(value: number[]) {
    return new SumowanieKwotService().suma(value);
  }

  updateFilterMobile(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function(d) {
      return (d.okres != null && d.okres.toString().toLowerCase().indexOf(val) !== -1) || 
             (d.rodzaj != null && d.rodzaj.toString().toLowerCase().indexOf(val) !== -1) ||
             (d.uwagi != null && d.uwagi.toString().toLowerCase().indexOf(val) !== -1) ||
             !val;
    });
    this._dane = temp;
  }

  sumaKwot(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.kwota || 0), 0);
  }

  private static zamienKwartalNaDate(kwartal: string): string {
    kwartal = kwartal.replace(/(\d{4}) kwartał (.*)/, '$1-$2');

    if (kwartal.endsWith('IV')) {
      return kwartal.replace('IV', '12');

    } else if (kwartal.endsWith('III')) {
      return kwartal.replace('III', '09');

    } else if (kwartal.endsWith('II')) {
      return kwartal.replace('II', '06');

    } else if (kwartal.endsWith('I')) {
      return kwartal.replace('I', '03');

    } else {
      return kwartal;
    }
  }

  public sortujPoOkresie(a: string, b: string): number {
    return ZusPodatkiTabelaComponent.zamienKwartalNaDate(a).localeCompare(ZusPodatkiTabelaComponent.zamienKwartalNaDate(b));
  }

  private odswiezKomunikatyTabeli() {
    this.komunikatyTabeli = this.komunikatyTabeliService.get();
  }

  private odswiezKolumnyPdf() {
    this.eksportKolumny = [
      {header: this.translate.instant('etykieta.lp'), dataKey: 'liczbaPorzadkowa'},
      {header: this.translate.instant('etykieta.data-wyplaty'), dataKey: 'kwota'},
      {header: this.translate.instant('etykieta.okres'), dataKey: 'okres'},
      {header: this.translate.instant('etykieta.rodzaj'), dataKey: 'rodzaj'},
      {header: this.translate.instant('etykieta.uwagi'), dataKey: 'uwagi'},
    ];

    this.eksportPdfKolumnyStyle = {
      liczbaPorzadkowa: { halign: 'right' },
      kwota: { halign: 'right' },
    };
  }
}
